import React from "react";
import { useNavigate } from "react-router-dom";
import img1 from "../images/10 yards.png";
import img2 from "../images/Bridal.png";
import img3 from "../images/One side.png";
import img4 from "../images/Double side.png";
import img5 from "../images/Pure cotton.png";
import img6 from "../images/lehenga.png";
import img7 from "../images/Fancy.png";
import img8 from "../images/collection1.png";
import img9 from "../images/collection2.png";
import img10 from "../images/cotton saree.png"

const collections = [
  { img: img1, name: "10 Yards", link: "/buy/10-yards", className: "w-full h-[320px] sm:h-[350px] md:h-[570px] lg:h-[630px] xl:h-[670px] 3xl:w-[420px] 3xl:h-[510px] 5xl:h-[550px] 8xl:w-[450px] 8xl:h-[638px] 9xl:w-[530px] 9xl:h-[760px] " },
  { img: img3, name: "One Side Border", link: "/buy/one-side-border", className: "w-full  h-[140px]  2xs:h-[140px] xs:h-[170px]  sm:h-[220px] md:h-[300px] lg:h-[330px] 3xl:w-[370px] 3xl:h-[260px] 5xl:h-[300px] 8xl:w-[430px] 8xl:h-[350px] 9xl:w-[500px] 9xl:h-[420px]" },
  { img: img4, name: "Double Side Border", link: "/buy/double-side-border", className: "w-full  h-[140px]  2xs:h-[140px] xs:h-[170px] sm:h-[220px] md:h-[300px] lg:h-[330px] 3xl:w-[460px] 3xl:h-[260px] 5xl:h-[300px] 8xl:w-[480px] 8xl:h-[350px] 9xl:w-[560px] 9xl:h-[420px] " },
  { img: img6, name: "Lehenga", link: "/buy/lehenga", className: "w-full h-[130px] xs:h-[150px] sm:h-[200px] md:h-[260px] lg:h-[280px] xl:h-[300px] 3xl:w-[440px] 3xl:h-[240px] 8xl:w-[490px] 8xl:h-[280px] 9xl:w-[550px] 9xl:h-[330px] " },
  { img: img5, name: "Pure cotton", link: "/buy/Pure-Cotton", className: "w-full  h-[100px] sm:h-[150px] 3xl:w-[375px] 3xl:h-[240px] 8xl:w-[420px] 8xl:h-[280px] 9xl:w-[505px] 9xl:h-[330px]" },
  { img: img2, name: "Bridal", link: "/buy/bridal", className: "w-full h-[180px] sm:h-[250px] md:h-[300px] lg:h-[340px] 3xl:w-[500px] 3xl:h-[270px] 5xl:w-[630px] 5xl:h-[300px] 6xl:w-[660px] 6xl:h-[330px]  7xl:w-[690px] 7xl:h-[360px] 8xl:w-[750px] 8xl:h-[400px] 9xl:w-[880px] 9xl:h-[430px]" },
  { img: img7, name: "Fancy", link: "/buy/fancy", className: "w-full  h-[140px]  2xs:h-[140px] xs:h-[170px]  sm:h-[220px] md:h-[300px] lg:h-[330px] 3xl:w-[400px] 3xl:h-[480px]" },
{ img: img10, name: "Pure cotton", link: "/buy/Pure-Cotton", className: "w-full  h-[140px]  2xs:h-[140px] xs:h-[170px]  sm:h-[220px] md:h-[300px] lg:h-[330px]" },
{ img: img9, name: "Double Side Border", link: "/buy/double-side-border", className: "w-full  h-[140px] 3xl:hidden  2xs:h-[140px] xs:h-[170px] sm:h-[220px] md:h-[300px] lg:h-[330px] 3xl:w-[460px] 3xl:h-[380px]" },
{ img: img8, name: "Fancy", link: "/buy/fancy", className: "w-full  h-[140px]  2xs:h-[140px] xs:h-[170px]  sm:h-[220px] md:h-[300px] lg:h-[330px]  3xl:h-[270px] 5xl:w-[500px] 5xl:h-[300px] 6xl:w-[555px] 6xl:h-[330px] 7xl:w-[560px] 7xl:h-[360px] 8xl:w-[620px] 8xl:h-[400px] 9xl:w-[710px] 9xl:h-[430px] " },
];

const ShopImage = ({ img, name, link, className }) => {
  const navigate = useNavigate();
  return (
    <div className="relative group  overflow-hidden">
      <div className="absolute bottom-2 3xl:bottom-6 left-2 z-10 font-bellefair text-[12px] xs:text-[16px] md:text-[23px] 3xl:text-xl 7xl:text-2xl 9xl:text-3xl  px-3 py-1 rounded font-bold text-[#fff] pointer-events-none group-hover:opacity-0 transition-opacity duration-300">
        {name}
      </div>
      <img
        className={className + " rounded-lg shadow-lg"}
        src={img}
        alt={name}
      />
      <div className="absolute inset-0 bg-black bg-opacity-60 flex items-end opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg">
        <div className="flex flex-col items-start p-4">
          <div className="text-[#fff] font-bellefair text-[12px] xs:text-[16px] md:text-[23px] 3xl:text-xl 7xl:text-2xl 9xl:text-3xl font-bold mb-2">{name}</div>
          <button
            className=" text-[#fff] border-2 py-1  rounded font-semibold font-sans text-[9px]  2xs:text-[12px] xs:px-[4px]  xs:text-[13px]  md:px-3 sm:text-[17px] xl:px-3 xl:text-[18px] 2xl:px-[7px]  2xl:text-[12px] 3xl:text-[13px] 4xl:px-[13px] 4xl:py-[2px] 4xl:text-[14px] 4xl:border-2 5xl:text-[17px] 7xl:px-3 7xl:text-[19px] 8xl:px-4 8xl:text-[25px] 9xl:px-5 9xl:text-[30px] 10xl:border-[7px] 10xl:px-8 10xl:text-[38px] 11xl:px-10 11xl:text-[57px]"
            onClick={() => navigate(link)}
          >
            Explore Now
          </button>
        </div>
      </div>
    </div>
  );
};


const Shop = () => {
  return (
    <div className="mt-4  9xl:mt-12 10xl:mt-20 11xl:mt-24">
      {/* Banner Images */}
     
      {/* Heading */}
      <div className="3xl:p-5">
        <h1 className="font-abhaya text-lg md:text-2xl 2xl:text-2xl 4xl:text-4xl 8xl:text-5xl 9xl:text-6xl 10xl:text-7xl 11xl:text-8xl text-center font-bold text-secondary tracking-[4px] 3xl:tracking-[7px] 8xl:tracking-[9px] mb-2 3xl:mb-4 mt-5 3xl:mt-3 8xl:mt-9">
          Shop by Collection
        </h1>
      </div>

      {/* Large screen layout */}
      <div className="hidden 3xl:block px-3 ">
        <div className="flex gap-2   justify-center">
          <ShopImage {...collections[0]} />
          <div>
            <div className="flex gap-2 mb-2 justify-center ">
              <ShopImage {...collections[1]} />
              <ShopImage {...collections[2]} />
            </div>
            <div className="flex gap-2 mb-2 justify-center ">
              <ShopImage {...collections[3]} />
              <ShopImage {...collections[4]} />
            </div>
          </div>
        </div>
        <div className="flex gap-2 mb-8 justify-center ">
          <ShopImage {...collections[5]} />
          <ShopImage {...collections[9]} />
        </div>
      </div>

      {/* Responsive layout for smaller screens */}
      <div className="3xl:hidden block px-2 sm:px-4">
        <div className="">
          <ShopImage {...collections[0]} />
          <div>
            <div className="flex gap-2 mt-2 mb-2  ">
              <div className="flex-1"><ShopImage {...collections[1]} /></div>
              <div className="flex-1"><ShopImage {...collections[8]} /></div>
            </div>
            <div className="mb-2">
              <ShopImage {...collections[3]} />
            </div>
          </div>
        </div>
        <div className="flex gap-2  ">
          <div className="flex-1"><ShopImage {...collections[7]} /></div>
          <div className="flex-1"><ShopImage {...collections[6]} /></div>
        </div>
        <div className="mt-2 mb-10">
          <ShopImage {...collections[5]} />
        </div>
      </div>
    </div>
  );
};

export default Shop;
